/**
 * @fileoverview POST handler for the "/engagement/remove_all_content_cards" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { engagementRemoveAllContentCardsCacheKeys } from "./constants";
import type { EngagementRemoveAllContentCardsResult, EngagementRemoveAllContentCardsProps } from "./types";

export const postEngagementRemoveAllContentCards = reactQueryMutationAdapter(
  engagementRemoveAllContentCardsCacheKeys,
  (props: EngagementRemoveAllContentCardsProps): Promise<EngagementRemoveAllContentCardsResult> => {
    return fetch("/engagement/remove_all_content_cards", "POST", props);
  }
);
